export const SET_DARKMODE = "SET_DARKMODE"
export const SET_LIGHTMODE = "SET_LIGHTMODE"

export const setDarkMode = () => {return {type: SET_DARKMODE}}
export const setLightMode = () => {return {type: SET_LIGHTMODE}}